export interface PriceGroupValues {
  sap_price_group_code: string;
  price_group_en: string;
  price_group_ar: string;
  display_price_group_en: string;
  display_price_group_ar: string;
  company_code: string;
  sales_organization: string;
  is_active: boolean;
}

export type ApprovalStatus = 'pending' | 'approved' | 'rejected';

export interface PriceGroupResponse extends PriceGroupValues {
  price_group_id: number;
  created_at: string;
  isSupplierRequest: boolean;
  approvalStatus: ApprovalStatus;
  supplier_id: number | string | null;
}

export interface PriceGroupRecord extends PriceGroupResponse {
  id: number;
  createdAt: Date;
}

export const PRICE_GROUP_EDITABLE_FIELDS = [
  'sap_price_group_code', 'price_group_en', 'price_group_ar',
  'display_price_group_en', 'display_price_group_ar',
  'company_code', 'sales_organization', 'is_active',
] as const;